module.exports = __webpack_public_path__ + "fonts/NetflixSansIcon.7a708006.ttf";